import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const sharedProps: Pick<LocDef, 'htmlAllowed' | 'shared' | 'feature' | 'portal'> = {
	htmlAllowed: false,
	shared: false,
	feature: HubFeature.OtherRequirementUploadCandidateAccessAudits,
	portal: 'CP',
};

type CPAuditHistoryMessageFormLoc =
	| 'CPAuditHistoryMessageFormTitle'
	| 'CPAuditHistoryMessageFormMessage'
	| 'CPAuditHistoryMessageFormMessageRequired'
	| 'CPAuditHistoryMessageFormSend'
	| 'CPAuditHistoryMessageFormSuccess';

export const cpAuditHistoryMessageFormLocs: LocDefs<CPAuditHistoryMessageFormLoc> = {
	CPAuditHistoryMessageFormTitle: {
		defaultValue: 'Send Messages to Audit Team',
		description: 'Section title for the audit history message form section.',
		displayPath: `History|Audit|Details|Message Form|Section Title`,
		displayType: 'Title',
		...sharedProps,
	},
	CPAuditHistoryMessageFormMessage: {
		defaultValue: 'Message',
		description: 'Message for the audit history message form section.',
		displayPath: `History|Audit|Details|Message Form|Message`,
		displayType: 'Label',
		...sharedProps,
	},
	CPAuditHistoryMessageFormMessageRequired: {
		defaultValue: 'Message is required',
		description: 'Message required for the audit history message form section.',
		displayPath: `History|Audit|Details|Message Form|Message Required`,
		displayType: 'Error',
		...sharedProps,
	},
	CPAuditHistoryMessageFormSend: {
		defaultValue: 'Send',
		description: 'Send for the audit history message form section.',
		displayPath: `History|Audit|Details|Message Form|Send`,
		displayType: 'Button',
		...sharedProps,
	},
	CPAuditHistoryMessageFormSuccess: {
		defaultValue: 'Message sent successfully',
		description: 'Success message for the audit history message form section.',
		displayPath: `History|Audit|Details|Message Form|Success`,
		displayType: 'Notification',
		...sharedProps,
	},
};

export const cpAuditHistoryMessageFormLocKeys = MapLocKeys<CPAuditHistoryMessageFormLoc>(
	cpAuditHistoryMessageFormLocs
);
export type CPAuditHistoryMessageFormLocKeys = typeof cpAuditHistoryMessageFormLocKeys;
